import React, {useContext, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {
	ContextServicePrice, ContextServicePriceProvider,
} from '@contexts/ContextServicePriceProvider'
import Price from '../../common/primitives/Price'
import styles from './ComponentServicePrice2022.scss'
import ServicePriceSelect from '../../common/primitives/ServicePriceSelect'
import {ContextCart} from '@contexts/ContextCartProvider'
import {ContextTaxonomy} from '@contexts/ContextTaxonomyProvider'
import HelperGoogleAnalytics from '../../common/helpers/HelperGoogleAnalytics'
import HelperGoogleAnalytics4 from '../../common/helpers/HelperGoogleAnalytics4'
import RenderIf from '../../common/primitives/RenderIf/RenderIf'
import DiscountTag2022 from '../../common/primitives/DiscountTag2022/DiscountTag2022'
import {__t} from '../../common/lang/text-resource'

const discountPositionMap = {
	plan_01: {
		top: 133,
		right: -20,
		bottom: 0,
		left: 0,
		rotate: 20,
	},
	plan_02: {
		top: 183,
		right: -20,
		bottom: 0,
		left: 0,
		rotate: -10,
	},
	plan_03: {
		top: 3,
		right: -20,
		bottom: 0,
		left: 0,
		rotate: 10,
	},
	gdpr_protect_1_1: {
		top: -20,
		right: -20,
		bottom: 0,
		left: 0,
		rotate: 20,
	},
	gdpr_protect_2_1: {
		top: -20,
		right: -20,
		bottom: 0,
		left: 0,
		rotate: -10,
	},
	gdpr_protect_3_1: {
		top: -20,
		right: -20,
		bottom: 0,
		left: 0,
		rotate: 10,
	}
}

const ComponentServicePrice2022 = ({
									   serviceId,
									   selectedTerm,
									   onSelectServicePrice,
									   showDiscountTag,
									   discountStickerPositions,
									   showPriceSelector,
									   showYearlyPrice,
									   removeDoubleZero,
									   showStar,
									   hostingPromo
								   }) => {
	/** @type ContextServicePriceProvider */
	const contextPrice = useContext(ContextServicePrice)
	const priceDataAll = contextPrice.getVOForId(serviceId)

	/** @type ContextTaxonomyProvider */
	const contextTaxonomy = useContext(ContextTaxonomy)
	const taxonomyData = contextTaxonomy.getForId(serviceId)


	/** @type ContextCartProvider */
	const cartContext = useContext(ContextCart)
	if (cartContext.isNewServiceInCart(serviceId)) {
		const cartLine = cartContext.getNewServiceData(serviceId)
		if (cartLine.length > 0) {
			selectedTerm = cartLine[0].termMonths
		}
	}

	const [selectedPrice, setSelectedPrice] = useState(
	  contextPrice.getVOForIdAndTerm(serviceId, selectedTerm)
	)

	if (!discountStickerPositions) {
		discountStickerPositions = discountPositionMap
	}

	const onSelectPrice = (selected) => {

		setSelectedPrice(selected);

		HelperGoogleAnalytics.TrackServicePriceSelectorClose(
		  taxonomyData,
		  true,
		  selected.termEn
		)
		HelperGoogleAnalytics4.TrackServicePriceSelectorClose(
		  taxonomyData,
		  true,
		  selected.termEn
		)
	}

	useEffect(() => {

		if (typeof onSelectServicePrice === 'function') {
			onSelectServicePrice(selectedPrice)
		}
	}, [selectedPrice])

	const basePrice = showYearlyPrice ? selectedPrice.basePriceNew : selectedPrice.monthlyBasePriceNew;
	const basePriceEUR = showYearlyPrice ? selectedPrice.basePriceNewAdditional : selectedPrice.monthlyBasePriceNewAdditional;
	const price = showYearlyPrice ? selectedPrice.priceNew : selectedPrice.monthlyPriceNew;
	const priceEUR = showYearlyPrice ? selectedPrice.priceNewAdditional : selectedPrice.monthlyPriceNewAdditional;
	// const termSeparator = selectedPrice.currency === 'BGN' ? '/' : ' ';
	const termText = showYearlyPrice ? __t('год') : __t('мес');
	const termSeparator = {
		"BGN": '/',
		"EUR": ' ',
	};

	return (
	  <>
		  <RenderIf condition={showDiscountTag === true}>
			  {hostingPromo === true ?
				<DiscountTag2022
				  {...discountStickerPositions[serviceId]}
				  value={selectedPrice.discount}
				  imageVariant={'percent-new'}
				  addPercent={true}
				/>
				:
				<DiscountTag2022
				  {...discountStickerPositions[serviceId]}
				  // value={selectedPrice.discount_sum}
				  // currency={selectedPrice.currency}
				  value={selectedPrice.discount}
				  imageVariant={'percent-new'}
				  addPercent={true}
				/>
			  }
		  </RenderIf>
		  <div className={styles.monthlyPriceContainer}>
			  <RenderIf
				condition={
				  parseFloat(basePrice) >
				  parseFloat(price)
				}
			  >
				  <div className={styles.oldPrice}>
					  <Price
						value={basePrice}
						currency={selectedPrice.currency}
						removeDoubleZeros={removeDoubleZero}
					  />
					  {termSeparator[selectedPrice.currency]}{termText}
				  </div>
			  </RenderIf>
			  <div>
				  <Price
					valueClass={styles.monthlyPrice}
					currencyClass={styles.monthlyPriceCurrency}
					value={price}
					currency={selectedPrice.currency}
					removeDoubleZeros={removeDoubleZero}
				  />
				  <span
					className={styles.monthlyPriceCurrency}>{termSeparator[selectedPrice.currency]}{termText}{showStar === true ? '*' : ''}</span>
			  </div>
		  </div>
		  <RenderIf condition={showPriceSelector === true}>
			  <div className={styles.selectContainer}>
				  <ServicePriceSelect
					name={`price_select_${serviceId}`}
					options={priceDataAll}
					selected={selectedPrice}
					onChange={onSelectPrice}
					onMenuOpen={() => {
						HelperGoogleAnalytics.TrackServicePriceSelectorOpen(
						  taxonomyData,
						  true
						)
						HelperGoogleAnalytics4.TrackServicePriceSelectorOpen(
						  taxonomyData,
						  true
						)
					}}
				  />
			  </div>
		  </RenderIf>
	  </>
	)
}

ComponentServicePrice2022.defaultProps = {
	selectedTerm: 1,
	showDiscountTag: false,
	discountStickerPositions: null,
	showPriceSelector: true,
	showYearlyPrice: false,
	removeDoubleZero: false,
	showStar: true,
	hostingPromo: false,
}
ComponentServicePrice2022.propTypes = {
	serviceId: PropTypes.string.isRequired,
	selectedTerm: PropTypes.number.isRequired,
	onSelectServicePrice: PropTypes.func,
	showDiscountTag: PropTypes.bool,
	discountStickerPositions: PropTypes.object,
	showPriceSelector: PropTypes.bool,
	showYearlyPrice: PropTypes.bool,
	removeDoubleZero: PropTypes.bool,
	showStar: PropTypes.bool,
	hostingPromo: PropTypes.bool,
}
export default ComponentServicePrice2022
